module.exports = __webpack_public_path__ + "img/zhiliang.be1755d2.png";